import styled from "styled-components";
import {
  COLORS,
  responsive,
} from "../../../../../../../../styles/constants.style";

export const ChangeProjectStatusWrapper = styled.div`
  .status-field {
    margin-top: 24px;
    ${responsive.MOBILE`
      margin-top: 16px;
    `}
  }

  .status-container {
    .status-label {
      color: ${COLORS.cirrus_black10};
    }
  }

  .MuiPickersTextField-root,
  .MuiPickersInputBase-root {
    width: 100%;
  }

  .form-container {
    padding: 16px 16px 24px 16px;
    ${responsive.MOBILE`
      padding: 0 16px 16px 16px;
    `}
  }

  .MuiTabs-flexContainer {
    border-bottom: 5px solid ${COLORS.cirrus_black3};
  }

  .form-field {
    padding: 24px 16px 16px 0px;
    ${responsive.MOBILE`
      padding: 0 0 0 0;
    `}
  }
`;
